/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolMovieIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-movie"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.48 3.25L5.42 7.2Q5.6 7.55 5.92 7.75Q6.25 7.95 6.65 7.95Q7.42 7.95 7.83 7.3Q8.22 6.65 7.88 5.95L6.53 3.25L8.57 3.25L10.53 7.2Q10.7 7.55 11.03 7.75Q11.35 7.95 11.75 7.95Q12.53 7.95 12.93 7.3Q13.32 6.65 12.97 5.95L11.63 3.25L13.68 3.25L15.63 7.2Q15.8 7.55 16.13 7.75Q16.45 7.95 16.85 7.95Q17.63 7.95 18.02 7.3Q18.43 6.65 18.07 5.95L16.73 3.25L20.15 3.25Q21.25 3.25 22.02 4.03Q22.8 4.8 22.8 5.9L22.8 18.1Q22.8 19.2 22.02 19.98Q21.25 20.75 20.15 20.75L3.85 20.75Q2.75 20.75 1.98 19.98Q1.2 19.2 1.2 18.1L1.2 5.9Q1.2 4.8 1.84 4.13Q2.48 3.45 3.48 3.25Z" fill={color} />
    </svg>
  );
}
